/**
 * Test IDs for QA automation.
 */
export const testIds = {
  forecastSimulatorUptick: "forecast-simulator-uptick",
  forecastSimulatorRunSimulation: "forecast-simulator-run-simulation",
  forecastSimulatorSaveOrders: "forecast-simulator-save-orders",
} as const;
